export default __webpack_public_path__ + "6dcc612887224b8fc5bf83a21dcb5d8f.png";